import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router doesn't reset scroll position on navigation the way a
// normal multi-page site does — clicking a nav link just swaps the page
// content in place, leaving the browser wherever it was scrolled to on
// the previous page. That's why clicking "About Us" while scrolled near
// a footer lands you looking at the new page's footer instead of its top.
// This runs window.scrollTo(0,0) every time the route (pathname) changes.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
